import { useTranslation } from 'react-i18next';
import type { SingleValue } from 'react-select';

import { SingleSelect } from '@/common';
import { Label, LABEL_TYPE } from '@/components/generic';
import { LANGUAGE_CODE } from '@/enums';
import { getLanguageOptions } from '@/helpers';
import { RegisterDescriptionPanel } from '@/pages/Register/RegisterDescriptionPanel';
import { RegisterForm } from '@/pages/Register/RegisterForm';
import { SentoaLogo } from '@/resources';
import { TestIds } from '@/shared/test-ids';
import type { SelectOptionProps } from '@/types';

export const Register = () => {
  const [t, i18n] = useTranslation('common');
  const languageOptions = getLanguageOptions();

  const storedLanguageRaw = localStorage.getItem('currentLanguage');
  const storedLanguageValue =
    storedLanguageRaw === null || storedLanguageRaw === '' ? NaN : Number(storedLanguageRaw);

  const handleLanguageChange = (selectedOption: SingleValue<SelectOptionProps>) => {
    const selectedValue = selectedOption ? Number(selectedOption.value) : LANGUAGE_CODE.DutchBE;
    localStorage.setItem('currentLanguage', String(selectedValue));
    void i18n.changeLanguage(LANGUAGE_CODE[selectedValue]);
  };

  return (
    <div className='min-h-screen'>
      <header className='fixed inset-x-0 top-0 z-20 border-b border-blue-powder bg-primary-white'>
        <div className='flex h-16 w-full items-center justify-between px-2 md:px-6'>
          <div data-testid={TestIds.registration.logo}>
            <SentoaLogo className='h-8 w-40' />
          </div>

          <div className='w-40'>
            <SingleSelect
              id='defaultLanguage'
              testId={TestIds.registration.defaultLanguageSelect}
              options={languageOptions}
              handleChange={handleLanguageChange}
              value={languageOptions.find(
                (option) =>
                  Number(option.value) ===
                  (Number.isNaN(storedLanguageValue) ? LANGUAGE_CODE.DutchBE : storedLanguageValue)
              )}
              containerClassName='flex-1'
              isClearable={false}
            />
          </div>
        </div>
      </header>

      <main className='flex min-h-dvh flex-col pt-16'>
        <div className='grid flex-1 grid-cols-1 md:grid-cols-2'>
          <RegisterDescriptionPanel />

          <section className='flex items-center justify-center bg-cream p-5 md:px-10'>
            <RegisterForm />
          </section>
        </div>

        <div className='flex w-full items-center justify-center bg-cream pb-2'>
          <Label text={t('regFooterRights')} type={LABEL_TYPE.PARAGRAPH1} />
        </div>
      </main>
    </div>
  );
};
